import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { IItemRenderer } from '../../interfaces/item-renderer.table';

@Component({
  selector: 'opt-bool-item-renderer',
  templateUrl: './bool-item-renderer.component.html',
  styleUrls: ['./bool-item-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoolItemRendererComponent implements OnInit, IItemRenderer {
  @Input() id: string;
  @Input() value: boolean;

  constructor() {}

  ngOnInit(): void {}
}
